import styled, { css } from "styled-components"

import { colors, spacing, typography } from "@izettle/otto"

import { SemanticState } from "../../enumerations"

import { InputCustomIconProps } from "./types"

const mixinInputControlRightPalette = css<InputCustomIconProps>`
  color: ${({ semanticState, isFocused, isDisabled }) => {
    if (isDisabled) {
      return colors.icon.disabled
    }
    if (isFocused) {
      return colors.icon.action
    }
    return {
      [SemanticState.Warning]: colors.icon.warning.small,
      [SemanticState.Error]: colors.icon.error.small,
      [SemanticState.Success]: colors.icon.success.small,
      [SemanticState.Default]: colors.icon.default,
    }[semanticState ?? SemanticState.Default]
  }};
`

export const InputCustomIcon = styled.div<InputCustomIconProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: ${spacing.small};
  ${mixinInputControlRightPalette}
`

export const InputCustomIconLeft = styled.div<InputCustomIconProps>`
  min-width: ${spacing.medium};
  max-width: ${spacing.medium};
  margin-left: ${spacing.small};
  overflow: hidden;
  padding: 0;
  display: flex;
  white-space: nowrap;
  justify-content: center;
  align-items: center;
  ${typography.large}
  ${mixinInputControlRightPalette}
`
